// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3wyw2","defaultSelect":"styles_defaultSelect__255Fe"};